export class SaveFilterFailureAction {
    public static readonly type = '[JobsPlacements] Save filter failure';
}
